import Video from 'app/components/tv/models/video';
import Playlist from 'app/components/tv/models/Playlist';
import WatchedPlaylist from 'app/components/tv/utils/WatchedPlaylist';

export class VideoToPlayDetection {
  constructor(private playlist: Playlist) {}

  handle = (slug?: string): Video => {
    if (slug) {
      return this.handleBySlug(slug);
    }
    const videoToPlayByLastWatched = this.handleByLastWatched();
    if (videoToPlayByLastWatched) {
      return videoToPlayByLastWatched;
    }
    return this.playlist.getFirstVideo();
  };

  private handleBySlug(slug: string) {
    const videoToPlayBySlug = this.playlist.findBySlug(slug);
    if (videoToPlayBySlug) {
      return videoToPlayBySlug;
    }
    throw new Error('Invalid video slug');
  }

  private handleByLastWatched(): Video | null {
    const lastWatchedVideoIndex = this.findLastWatchedVideoIndex();
    if (!lastWatchedVideoIndex) {
      return null;
    }
    return this.playlist.findByIndex(lastWatchedVideoIndex + 1);
  }

  private findLastWatchedVideoIndex(): number | null {
    return new WatchedPlaylist(this.playlist.getPlaylistId()).getWatchedVideoIndex();
  }
}
